import type React from 'react';
import { createContext, useContext } from 'react';

import { type GoodsType } from '@/common/types/goods';
import { type PlantTypeText } from '@/common/types/plant';
import { type ResourceTypeText } from '@/common/types/resource';
import { type HelpTextType } from '@/components/Modals/HelpModal/HelpTextConfig';

interface ModalContextProps {
  sellModalParams: SellParams | null;
  setSellModalParams: React.Dispatch<React.SetStateAction<SellParams | null>>;
  openTCoinModal: boolean;
  setOpenTCoinModal: React.Dispatch<React.SetStateAction<boolean>>;
  isGoodsBoostModalOpen: boolean;
  setIsGoodsBoostModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isFactoryBoostModalOpen: boolean;
  setIsFactoryBoostModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isQuarryBoostModalOpen: boolean;
  setIsQuarryBoostModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  openNewGoodsModal: boolean;
  setOpenNewGoodsModal: React.Dispatch<React.SetStateAction<boolean>>;
  earnRewardModal: boolean;
  setEarnRewardModal: React.Dispatch<React.SetStateAction<boolean>>;
  helpModal: boolean;
  setHelpModal: React.Dispatch<React.SetStateAction<boolean>>;
  imgNewGoods: string;
  newGoods: (img: string) => void;
  openSellModal: boolean;
  setOpenSellModal: React.Dispatch<React.SetStateAction<boolean>>;
  openClaimModal: boolean;
  setOpenClaimModal: React.Dispatch<React.SetStateAction<boolean>>;
  idResourse: string;
  setIdResourse: React.Dispatch<React.SetStateAction<string>>;
  helpType: HelpTextType;
  setHelpType: React.Dispatch<React.SetStateAction<HelpTextType>>;
  tekstClaimModal: string;
  setTekstClaimModal: React.Dispatch<React.SetStateAction<string>>;
  helpTextModal: (type: HelpTextType) => void;
  sellModal: (data: SellParams) => void;
  claimModal: (tekst: string) => void;
  buildResourceRef: React.RefObject<HTMLDivElement>;
  scrollToBuildResource: () => void;
}

interface SellParams {
  key: ResourceTypeText | PlantTypeText | GoodsType;
  value: {
    value: number;
    costPerUnit: number;
  };
  achieveValue?: number;
}
const ModalContext = createContext<ModalContextProps | undefined>(undefined);
const useModal = (): ModalContextProps => {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }

  return context;
};

export { ModalContext, type SellParams, useModal };
